<template>
    <div class="product-item">
        <a :href="route('products.show', product.id)" class="product-item-primary-link">
            <div class="product-item-image">
                <ProductPromotionBadges :badges="promotionBadges" />

                <div class="product-item-image__media img-loader">
                    <img
                        :src="product.images[0]['md']"
                        alt="asd"
                        width="270"
                        height="250"
                        loading="lazy"
                        :class="{'product-image--contain': isJobDefaultImage}"
                        @error="changeToDefaultImage($event)"
                        @load="removeLoaderClass($event)"
                    />
                </div>

                <div class="product-item-buttons">
                    <button
                        type="button" :data-product-id="product.id"
                        :class="{active: product.is_favorite}"
                        class="product-item-button btn-unstyled product-item-favorite"
                    >
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none">
                            <path
                                d="M5 1C2.7912 1 1 2.73964 1 4.88594C1 6.61852 1.7 10.7305 8.5904 14.8873C8.71383 14.961 8.85552 15 9 15C9.14448 15 9.28617 14.961 9.4096 14.8873C16.3 10.7305 17 6.61852 17 4.88594C17 2.73964 15.2088 1 13 1C10.7912 1 9 3.35511 9 3.35511C9 3.35511 7.2088 1 5 1Z"
                                stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>

                    <button
                        type="button"
                        :data-product-id="product.id"
                        class="product-item-button btn-unstyled product-item-quick-view"
                    >
                        <i class="bi bi-eye"></i>
                    </button>
                </div>
            </div>

            <div class="product-item-content">
                <strong>{{ product.title }}</strong>
                <span v-if="gridCity" class="product-item-city text-sm d-block">{{ gridCity }}</span>
                <span v-if="lastModifiedDisplay" class="product-item-date text-sm d-block">{{ lastModifiedDisplay }}</span>
                <div class="product-item-list-content">
                    <span class="text-sm d-block">
                        {{ product.categoryName }}
                    </span>
                    <p>{{ product.description }}</p>
                </div>

                <span v-if="showsPrice">{{ formattedPrice }}</span>
            </div>
        </a>
        <a
            v-if="sellerLink"
            :href="sellerLink"
            class="product-item-seller-link"
            @click.stop
        >
            {{ sellerLabel }}
        </a>
    </div>
</template>

<script>
import ProductPromotionBadges from './ProductPromotionBadges.vue';
import formatProductPrice from '../../core/formatProductPrice';

export default {
    name: 'ProductItem',
    components: {
        ProductPromotionBadges,
    },
    props: {
        product: {
            type: Object,
            required: true,
        }
    },
    computed: {
        gridCity() {
            const city = this.product?.city ?? '';

            return typeof city === 'string' ? city.trim() : '';
        },
        lastModifiedDisplay() {
            const display = this.product?.lastModifiedDisplay ?? '';

            return typeof display === 'string' ? display.trim() : '';
        },
        isJobDefaultImage() {
            const url = this.product?.images?.[0]?.md ?? '';

            return typeof url === 'string' && url.includes('job-for-you.jpg');
        },
        sellerLink() {
            if (this.product.author && this.product.author.seller_listing_url) {
                return this.product.author.seller_listing_url;
            }
            if (this.product.userId) {
                return this.route('seller.show', this.product.userId);
            }
            return null;
        },
        sellerLabel() {
            if (this.product.author && this.product.author.display_name) {
                return this.product.author.display_name;
            }
            const a = this.product.author;
            if (a && (a.first_name || a.last_name)) {
                return [a.first_name, a.last_name].filter(Boolean).join(' ');
            }
            return this.$trans('main.Seller');
        },
        promotionBadges() {
            return Array.isArray(this.product?.promotionBadges) ? this.product.promotionBadges : [];
        },
        showsPrice() {
            if (typeof this.product?.shows_price === 'boolean') {
                return this.product.shows_price;
            }

            return Boolean(this.product?.has_price) && Number(this.product?.price) > 0;
        },
        formattedPrice() {
            return formatProductPrice(this.product?.price);
        },
    },
    methods: {
        changeToDefaultImage() {
            window.changeToDefaultImage(event);
        },
        removeLoaderClass() {
            window.removeLoaderClass(event);
        },
    }
}
</script>
